import { action, observable } from 'mobx';

export interface IPopupComponentProps {
  when: boolean;
  section: string;
  onOK?: any;
  onCancel?: any;
  onAction?: any;
  text?: string;
  cancelText?: string;
  okText?: string;
  actionText?: string;
}

export class UserLeavingWarningVM {
  props: IPopupComponentProps;

  constructor(props: IPopupComponentProps) {
    this.props = props;
  }

  @observable showPrompt: boolean = false;
  @action.bound setShowPrompt(value) {
    this.showPrompt = value;
  }

  @observable currentPath: string = '';
  @action.bound setCurrentPath(value) {
    this.currentPath = value;
  }

  @action.bound close() {
    this.showPrompt = false;
  }
}
